export default "__VITE_ASSET__BlGIsLQg__"